module.exports = __webpack_public_path__ + "img/icon_ai.62b8e4ae.svg";